// extracted by mini-css-extract-plugin
export var fullWidthButton = "_eq-0";